import React from "react"
import { useStaticQuery, graphql } from "gatsby"

// Data
import siteContent from "../../content/siteContent"

// Styles
import * as styles from "./SponsorsLogos.module.scss"
import Image from "../Shared/Image"
import { imageSizes } from "../../helpers/imgix"

const SponsorsLogos = () => {
    const data = useStaticQuery(graphql`
        query SponsorLogosQuery {
            wp {
                footerSettings {
                    footer_logos {
                        logos {
                            image {
                                id
                                sourceUrl
                                title
                            }
                            link {
                                url
                                title
                            }
                            size
                        }
                    }
                }
            }
        }
    `)
    return (
        <ul className={styles.SponsorsLogos}>
            {data.wp.footerSettings.footer_logos.logos.map((logo, index) => (
                <li key={`sponsor-logo-${index}`} className={logo.size}>
                    {logo.link && (
                        <a href={logo.link.url}>
                            <Image url={logo.image.sourceUrl} alt="Logo" sizes={imageSizes.logo} />
                            <span>{logo.image.title}</span>
                        </a>
                    )}

                    {!logo.link && (
                        <>
                            <Image url={logo.image.sourceUrl} alt="Logo" sizes={imageSizes.logo} />
                            <span>{logo.image.title}</span>
                        </>
                    )}
                </li>
            ))}
        </ul>
    )
}

export default SponsorsLogos
